class Message {
	flash(message, level = 'success') {
		let html = this.render(message, level)
		$('[data-message-container]').append(html);
		$('[data-message-container] .toast:not(.active)').each((index, element) => {
			let $element = $(element);
			$element.addClass('active');
			$element.addClass('show');
			setTimeout(() => {
				$element.removeClass('show');
				$element.addClass('hide');

				setTimeout(() => {
					$element.removeClass('hide');
					$element.addClass('d-none');
				}, 200)
			}, 4000)
		})
	}

	success(message) {
		this.flash(message, 'success');
	}

	info(message) {
		this.flash(message, 'info');
	}

	error(message) {
		this.flash(message, 'danger');
	}

	wrongInputError() {
		this.error('Er zijn fouten opgetreden controleer uw invoer en probeer het nog een keer');
	}

	warning(message) {
		this.flash(message, 'warning');
	}

	render(message, level) {
		return `
			<div class="toast fade align-items-center text-bg-${level} border-0" role="alert" aria-live="assertive" aria-atomic="true">
      			<div class="d-flex">
        			<div class="toast-body">${message}</div>
        			<button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
      			</div>
    		</div>
		`;
	}
}

export default Message;